import { motion } from "framer-motion";
import Lottie from "lottie-react";
import cartUpdate from "../animations/cart.json";

export default function UpdateCart() {

    return (
        <div style={{
            width: "100vw",
            height: "100vh",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            flexDirection: "column",
            position: 'fixed',
            top: 0,
            backgroundColor: "#171717"
        }}>
            <motion.div animate={{ scale: 1, opacity: 1 }} initial={{ scale: 0.5, opacity: 0 }} style={{ width: "100vw", aspectRatio: 1 }}>
                <Lottie 
                    animationData={cartUpdate}
                    loop={false}
                />
            </motion.div>
            <motion.p animate={{ scale: 1, opacity: 1 }} initial={{ scale: 0.5, opacity: 0 }}>Item added to cart</motion.p>
        </div>
    )
}